import React from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
interface ItemProps {
  title: string;
  text?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  testId?: string;
}
const ScheduledFilterItem: React.FC<ItemProps> = ({
  testId = 'scheduled-report_filter-item',
  title,
  text,
  isLoading,
  children,
}) => (
  <Box direction="column" style={{ flex: 1 }}>
    <Text data-testid={`${testId}_title`} size="small" color="textSecondary">
      {title}
    </Text>
    {isLoading ? (
      <ShimmerBox data-testid={`${testId}_loading`} height="20px" width="55px" round="4px" />
    ) : (
      <Text
        data-testid={`${testId}_children`}
        truncate
        margin={{ right: 'spacing12' }}
        size="medium"
        weight={400}
        color="textBody"
        title={text}
      >
        {text || children || EMPTY_FIELD_VALUE}
      </Text>
    )}
  </Box>
);

export default ScheduledFilterItem;
